import { useEffect, useRef, useState } from "react";
import images from "../../../images";

export const CustomSelect = ({
  options,
  value, // Chuỗi, ví dụ: "male"
  onChange, // Trả về đối tượng { value, label }
  placeholder,
  icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange(option); // Trả về toàn bộ đối tượng option { value, label }
    setIsOpen(false);
  };

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <div className="relative w-full" ref={selectRef}>
      {/* Select Button */}
      <div
        className="flex items-center justify-between w-full rounded-lg cursor-pointer px-4 py-1 text-base"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span
          className={`text-base ${
            !selectedOption ? "text-gray-400" : "text-black"
          }`}
        >
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <img src={images.ChevronDownIcon} alt="" className="w-5 h-5" />
      </div>

      {/* Dropdown Options */}
      {isOpen && (
        <div className="absolute top-10 left-[-40px] min-w-[280px] w-full z-50 bg-white border border-gray-300 shadow-lg max-h-60 overflow-y-auto mt-1">
          {options.map((option) => (
            <div
              key={option.value}
              className={`px-4 py-3 cursor-pointer hover:bg-gray-100 transition-colors ${
                option.value === value
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-700"
              }`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
